import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/index.vue')
  },
  {
    path: '/comics',
    name: 'AllComics',
    component: () => import('@/views/AllComics.vue')
  },
  {
    path: '/update',
    name: 'UpdateList',
    component: () => import('@/views/UpdateList.vue')
  },
  {
    path: '/rankings',
    name: 'Rankings',
    component: () => import('@/views/Rankings.vue')
  },
  {
    path: '/vip',
    name: 'VipComics',
    component: () => import('@/views/VipComics.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/user',
    name: 'UserCenter',
    component: () => import('@/views/UserCenter.vue')
  },
  {
    path: '/comic/:id',
    name: 'ComicDetail',
    component: () => import('@/views/ComicDetail.vue')
  },
  {
    path: '/reader/:id',
    name: 'ChapterReader',
    component: () => import('@/views/ChapterReader.vue')
  },
  {
    path: '/agreement/:type',
    name: 'Agreement',
    component: () => import('@/views/Agreement.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
